module.exports = __webpack_public_path__ + "img/ru.6e8cc30d.svg";